import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-name-category-selector"
export default class extends Controller {
  static targets = ["fileInput"]

  connect() {
    this.fileQueue = []
    this.setupFileInputListener()
    this.setupFieldCreatedListener()
  }

  setupFileInputListener() {
    // Find the file input - it might be a target or we need to find it
    const fileInput = this.hasFileInputTarget 
      ? this.fileInputTarget 
      : this.element.querySelector('[data-js="active-storage-multiple-input"]')
    
    if (fileInput) {
      fileInput.addEventListener('change', this.handleFileSelection.bind(this))
    }
  }

  setupFieldCreatedListener() {
    // Listen for when new duplicatee fields are created
    this.element.addEventListener('field-duplicatee:created', this.handleFieldCreated.bind(this))
  }

  handleFileSelection(event) {
    const files = Array.from(event.target.files)
    this.fileQueue = files.map(file => file.name)
  }

  handleFieldCreated(event) {
    const { fieldElement, filename } = event.detail
    
    // Use the filename from the event detail, or fall back to queue
    const fileToCheck = filename || (this.fileQueue.length > 0 ? this.fileQueue.shift() : null)
    if (!fileToCheck) return

    this.detectCategory(fieldElement, fileToCheck)
  }

  detectCategory(fieldElement, filename) {
    const categorySelect = fieldElement.querySelector('select[name*="[category]"]')
    
    if (!categorySelect) return

    const normalizedFilename = filename.replace(/\s/g, '_').toLowerCase()

    let categoryFoundIndex = -1
    Array.prototype.forEach.call(categorySelect.options, function(option, i) {
      if (normalizedFilename.indexOf(option.value) !== -1) {
        categoryFoundIndex = i
      }
    })

    if (categoryFoundIndex !== -1) {
      categorySelect.value = categorySelect.options[categoryFoundIndex].value
    }
  }
}

